import React from "react"
import { Link } from "gatsby"
import type { Crumb } from "../seo/schema/breadcrumbList"

type BreadcrumbsProps = {
  crumbs: Crumb[]
}

export const Breadcrumbs = ({ crumbs }: BreadcrumbsProps) => (
  <nav
    aria-label="Breadcrumb"
    className="container mx-auto px-5 pt-5 text-sm text-gray-500"
  >
    <ol className="flex flex-wrap items-center">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1
        return (
          <li key={crumb.to} className="flex items-center">
            {isLast ? (
              <span aria-current="page" className="text-gray-700">
                {crumb.name}
              </span>
            ) : (
              <Link to={crumb.to} className="hover:text-purple-600">
                {crumb.name}
              </Link>
            )}
            {!isLast && <span className="mx-2 text-gray-400">/</span>}
          </li>
        )
      })}
    </ol>
  </nav>
)
